<template>
  <WizardStep id="personal" label="Persönliche Angaben">
    
<FormKitLazyProvider config-file="true">
<div>
      <FormKit
        type="checkbox"
        name="isCustomer"
        :label="
          $texts(
            'wizard.isAlreadyCustomer',
            'Ich bin bereits Kundin oder Kunde der Schaffhauser Kantonalbank',
          )
        "
      />
      <FormKit
        type="radio"
        name="salutation"
        label="Anrede"
        outer-class="is-inline"
        :options="{ m: 'Herr', w: 'Frau' }"
        validation="required"
      />
      <FormKit type="text" name="company" label="Firma" />
      <div class="flex gap-16">
        <FormKit
          type="text"
          name="firstName"
          label="Vorname"
          validation="required"
        />
        <FormKit
          type="text"
          name="lastName"
          label="Nachname"
          validation="required"
        />
      </div>
      <FormKit
        type="date"
        name="birthdate"
        label="Geburtsdatum"
        validation="required"
      />
    </div>
</FormKitLazyProvider>

  </WizardStep>
</template>

<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
const { $texts } = useEasyTexts()
</script>
